const apiActionsTypes = {
  GET_STATES_DATA_START: 'GET_STATES_DATA_START',
  GET_STATES_DATA_SUCCESS: 'GET_STATES_DATA_SUCCESS',
  GET_STATES_DATA_FAIL: 'GET_STATES_DATA_FAIL',
  GET_EVENTS_DATA_START: 'GET_EVENTS_DATA_START',
  GET_EVENTS_DATA_SUCCESS: 'GET_EVENTS_DATA_SUCCESS',
  GET_EVENTS_DATA_FAIL: 'GET_EVENTS_DATA_FAIL',
  GET_LAWYERS_DATA_START: 'GET_LAWYERS_DATA_START',
  GET_LAWYERS_DATA_SUCCESS: 'GET_LAWYERS_DATA_SUCCESS',
  GET_LAWYERS_DATA_FAIL: 'GET_LAWYERS_DATA_FAIL',
  GET_REPRESENTATIVES_DATA_START: 'GET_REPRESENTATIVES_DATA_START',
  GET_REPRESENTATIVES_DATA_SUCCESS: 'GET_REPRESENTATIVES_DATA_SUCCESS',
  GET_REPRESENTATIVES_DATA_FAIL: 'GET_REPRESENTATIVES_DATA_FAIL',
  GET_VOTE_LOCATIONS_DATA_START: 'GET_VOTE_LOCATIONS_DATA_START',
  GET_VOTE_LOCATIONS_DATA_SUCCESS: 'GET_VOTE_LOCATIONS_DATA_SUCCESS',
  GET_VOTE_LOCATIONS_DATA_FAIL: 'GET_VOTE_LOCATIONS_DATA_FAIL',
  GET_MENU_LIST_DATA_START: 'GET_MENU_LIST_DATA_START',
  GET_MENU_LIST_DATA_SUCCESS: 'GET_MENU_LIST_DATA_SUCCESS',
  GET_MENU_LIST_DATA_FAIL: 'GET_MENU_LIST_DATA_FAIL',
  GET_PAGE_LIST_DATA_START: 'GET_PAGE_LIST_DATA_START',
  GET_PAGE_LIST_DATA_SUCCESS: 'GET_PAGE_LIST_DATA_SUCCESS',
  GET_PAGE_LIST_DATA_FAIL: 'GET_PAGE_LIST_DATA_FAIL',
  GET_COPIES_LIST_DATA_START: 'GET_COPIES_LIST_DATA_START',
  GET_COPIES_LIST_DATA_SUCCESS: 'GET_COPIES_LIST_DATA_SUCCESS',
  GET_COPIES_LIST_DATA_FAIL: 'GET_COPIES_LIST_DATA_FAIL',
};

export default apiActionsTypes;
